import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export type WizardShellContextValue = {
  setFooter: (footer: ReactNode) => void;
  setAside: (aside: ReactNode) => void;
};

export const WizardShellContext = createContext<WizardShellContextValue | null>(null);

export const useWizardShell = (): WizardShellContextValue | null => useContext(WizardShellContext);

export type WizardEditOverlayValue = {
  /** Returns to the review screen; replaces the step's own close and Back handling while it renders as an edit modal. */
  onClose: () => void;
  /** Review-section heading shown as the edit modal's header instead of the step's own. */
  title?: string;
};

export const WizardEditOverlayContext = createContext<WizardEditOverlayValue | null>(null);

export const useWizardEditOverlay = (): WizardEditOverlayValue | null => useContext(WizardEditOverlayContext);
